export interface RekapIntakeOutput {
  shift1_intake: number | null;
  shift1_output: number | null;
  shift2_intake: number | null;
  shift2_output: number | null;
  shift3_intake: number | null;
  shift3_output: number | null;
  total_intake: number;
  total_output: number;
  balance: number;
}

export interface BblAlertItem {
  jam: number;
  param: string;
  level: "critical" | "warning";
  value: number;
  message: string;
}

export interface CatatanHarianBblObservasiInterface {
  id: number;
  catatan_harian_bbl_id: number;
  jam: number;
  suhu: number | null;
  spo2: number | null;
  rr: number | null;
  hr: number | null;
  feses: string | null;
  muntah_residu: string | null;
  urin: string | null;
  minuman_oral: string | null;
  minuman_iv: string | null;
  catatan_tindakan: string | null;
  perawat_user_id: number;
  perawat?: any;
  alert_level: Array<{ param: string; level: string; value: number; message: string }>;
  created_at: string;
  updated_at: string;
}

export interface DubowitzScoresPayload {
  neuro: Record<string, number | null>;
  fisik: Record<string, number | null>;
}

export interface CatatanHarianBblInterface {
  id: number;
  pasien_rm: string;
  register_id: number;
  unit_id: string;
  tanggal: string;
  bb_lahir: number | null;
  bb_sekarang: number | null;
  umur_kehamilan: number | null;
  dubowitz_scores: DubowitzScoresPayload | null;
  dubowitz_total: number | null;
  ruang: string | null;
  dpjp_user_id: number | null;
  dpjp_signed_at: string | null;
  catatan_umum: string | null;
  rekap_intake_output: RekapIntakeOutput;
  creator_user_id: number;
  observasi: CatatanHarianBblObservasiInterface[];
  alerts: BblAlertItem[];
  pasien?: any;
  dpjp?: any;
  creator?: any;
  created_at: string;
  updated_at: string;
}

export interface CatatanHarianBblListItem {
  id: number;
  tanggal: string;
  bb_sekarang: number | null;
  ruang: string | null;
  observasi_count: number;
  is_dpjp_verified: boolean;
  alert_count: number;
  pencatat: string | null;
  dpjp: string | null;
}

export const NEONATAL_VITAL_RANGES = {
  suhu: { normal_min: 36.5, normal_max: 37.5, warning_min: 36.0, warning_max: 38.0, critical_min: 36.0, critical_max: 38.0 },
  spo2: { normal_min: 95, warning_min: 90, critical_min: 90 },
  hr: { normal_min: 100, normal_max: 160, critical_min: 100, critical_max: 180 },
  rr: { normal_min: 40, normal_max: 60, critical_min: 30, critical_max: 70 },
};

export const RUANG_OPTIONS = ["NICU", "A", "C", "D", "Rawat Gabung"];
